module.exports = __webpack_public_path__ + "static/media/insta-3-min.2d1f1221.png";